import { getMissionsAnalyticsFunctionDef } from '../../../../backend/features/mission/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
export const missionsAnalyticsFetchKey = 'missionsAnalytics';
export const useMissionsAnalytics = () => {
    var _a, _b;
    const getMissionsAnalyticsPlatformFn = useTypedPlatformFunction(getMissionsAnalyticsFunctionDef);
    const { data: missionAnalytics, mutate, isLoading, } = useSWR(missionsAnalyticsFetchKey, () => getMissionsAnalyticsPlatformFn(null).catch(handleErrorSnackbar), defaultFetcherOptions);
    return {
        fetchMissionAnalytics: mutate,
        totalMissionsCount: (_a = missionAnalytics === null || missionAnalytics === void 0 ? void 0 : missionAnalytics.totalMissions) !== null && _a !== void 0 ? _a : 0,
        totalVolunteersHours: (_b = missionAnalytics === null || missionAnalytics === void 0 ? void 0 : missionAnalytics.totalParticipantHours) !== null && _b !== void 0 ? _b : 0,
        isLoading,
    };
};
